import React, { memo, Suspense, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { UploadFiles } from '../../../../../components/v2/upload-files'
import { deleteTimeLineItem } from '../../../../../store/timeline/actions'
import {
  ActivityTimelineContextProps,
  ActivityTimeline,
  ActivityTimelineContext,
  selectTimelineIsLoading,
  selectTimelineError,
  selectTimelineFiles
} from '../../../../../components/v2/activity-timeline'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'

const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

interface filesTimelineProps {
  className?: string
  id: string | number
}

export const CardFiles: React.FC<filesTimelineProps> = memo((props: filesTimelineProps) => {
  const { id, className } = props
  const dispatch = useAppDispatch()
  const timelineIsLoading = useSelector(selectTimelineIsLoading)
  const timelineError = useSelector(selectTimelineError)
  const timelineFiles = useSelector(selectTimelineFiles)
  const entityType = 'claim_work'

  const deleteAppealsTimelineItem = useCallback((activityItem) => {
    dispatch(deleteTimeLineItem(activityItem))
  }, [])

  const defaultProps = useMemo(
    (): ActivityTimelineContextProps => ({
      card_id: id,
      card_type: entityType,
      deleteTimelineItem: deleteAppealsTimelineItem,
    }),
    [id],
  )

  return (
    <FilesContainer>
      <Suspense fallback={''}>
        <UploadFiles
          entityType={entityType}
          entityId={id}
          url={`/api/${entityType}/${id}/add-file`}
          method='POST'
        />
      </Suspense>
      <Suspense fallback={''}>
        <ActivityTimelineContext.Provider value={defaultProps}>
          <ActivityTimeline
            isLoading={timelineIsLoading}
            items={timelineFiles}
            error={timelineError}
            className={className}
            emptyMessage={'Нет прикрепленных файлов'}
          />
        </ActivityTimelineContext.Provider>
      </Suspense>
    </FilesContainer>
  )
})
